// extracted by mini-css-extract-plugin
export default {"videoContainer":"index_videoContainer__3hKGc"};